export const errors = {

    400: "Bad Request",
    401: "Unauthorized, you don't have permission to receive that content",
    403: "Forbidden, doesn't have the correct role to execute the action",
    404: "Not Found",
    500: "Internal Server Error",
    503: "Service Unavailable",
    920: "Uncontrolled error"
}

export function errorMessage(code) {
    switch (code) {
        case 400:
            return "Bad Request";
        case 401:
            return "Unauthorized, you don't have permission to receive that content";
        case 403:
            return "Forbidden, doesn't have the correct role to execute the action";
        case 404:
            return "Not Found";
        case 503:
            return "Service Unavailable";
        case 920:
            return "Uncontrolled error";
        default:
            return "Internal Server Error";

    }
}